// extracted by mini-css-extract-plugin
module.exports = {"root":"userTable_root__2FGJZ","wrapper":"userTable_wrapper__1TZ2G","loaderContainer":"userTable_loaderContainer__zlUZn"};